import React from 'react';
import PropTypes from 'prop-types';
import { IconButton, Box } from '@material-ui/core';
import { Typography, ArrowBackIcon } from '@orijinworks/frontend-commons';
import { useCasePlanCreateHeaderStyles } from './CasePlanCreateHeader.styles';

/**
 * Page header with back navigation and create-flow title.
 */
export const CasePlanCreateHeader = ({ title, onBack }) => {
  const classes = useCasePlanCreateHeaderStyles();

  return (
    <Box className={classes.root}>
      <Box className={classes.titleRow}>
        <IconButton
          className={classes.backButton}
          onClick={onBack}
          aria-label="Back to all plans"
          size="small"
        >
          <ArrowBackIcon />
        </IconButton>
        <Typography variant="h1" className={classes.title}>
          {title}
        </Typography>
      </Box>
    </Box>
  );
};

CasePlanCreateHeader.propTypes = {
  title: PropTypes.string,
  onBack: PropTypes.func.isRequired,
};

CasePlanCreateHeader.defaultProps = {
  title: 'Create a New Plan',
};

export default CasePlanCreateHeader;
